import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IButton from "Screens/components/iButton";
import MainPara from "Screens/components/MainPara";
import { decodeText } from "Utils/Helpers/TextDecoder";
import BlogHead from "./BlogHead";

export default function Blogs({}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { blog } = useSelector((state) => ({
    blog: state.data.blog,
  }));

  const onOpen = (id) => {
    navigate(`/blogs/${id}`);
  };

  return (
    <>
      <MainPara title={"blogsPageTitle"} charType align={"text-left"} />
      <div className="blogs-exhibition">
        {blog &&
          blog.map((item) => {
            return (
              <div className="blogs-items-show-one" key={item.id}>
                <div className="blogs-items-show-one-image">
                  <img src={item.image} alt={item.id} />
                </div>
                <div className="blogs-items-show-one-infos">
                  <BlogHead item={item} />
                  <div className="blog-tags">
                    {item.tags.split(",").map((i, index) => {
                      return (
                        <p key={`tags-${item.id}-${index}`}>
                          <span>#</span>
                          {i}
                        </p>
                      );
                    })}
                  </div>
                  <div className="blog-short-description">
                    <div
                      className="short-content"
                      dangerouslySetInnerHTML={{
                        __html: decodeText(t(item.description)),
                      }}
                    />
                    <i
                      className="blogs-read-more"
                      onClick={() => onOpen(item.id)}
                    >
                      {t("Read More")}
                    </i>
                    <IButton
                      label={"Read More"}
                      onClick={() => onOpen(item.id)}
                      className="blogs-button"
                    />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}
